import bact from '@/sui/data/sheets/edit/bact'
import catheter from '@/sui/data/sheets/edit/catheter'
import micro from '@/sui/data/sheets/edit/micro'
import multi from '@/sui/data/sheets/edit/multi'
import patient from '@/sui/data/sheets/edit/patient'
import tools from '@/sui/data/sheets/edit/tools'
import fields from '@/sui/data/sheets/edit/fields'
import cfg from '@/sui/data/sheets/edit/cfg/neoInfADI'
import notes from '@/sui/data/sheets/edit/notes/neoInfADI'

const titles = {
  v1: [
    {
      text: 'DONNÉES ADMINISTRATIVES DU PATIENT',
      type: 'title',
      start: 'uf'
    },
    {
      text: 'DEVENIR DU PATIENT',
      type: 'title',
      start: 'dead'
    },
    {
      text: `DONNÉES RELATIVES À L'EXPOSITION AUX CATHÉTERS CENTRAUX`,
      type: 'title',
      start: 'catheters'
    },
    {
      text: 'SEPSIS ET BACTÉRIÉMIES NON LIÉS À UN CATHÉTER CENTRAL OU OMBILICAL',
      type: 'title',
      start: 'sepsis'
    }
  ],

  v2: [
    {
      text: 'DONNÉES ADMINISTRATIVES DU PATIENT',
      type: 'title',
      start: 'uf'
    },
    {
      text: 'DEVENIR DU PATIENT',
      type: 'title',
      start: 'dead'
    },
    {
      text: `DONNÉES RELATIVES À L'EXPOSITION AUX CVC OU CVO`,
      type: 'title',
      start: 'catheters'
    },
    {
      text: 'SEPSIS ET BACTÉRIÉMIES NON LIÉS À UN CVC OU À UN CVO',
      type: 'title',
      start: 'sepsis'
    }
  ],

  v3: [
    {
      text: 'DONNÉES ADMINISTRATIVES DU PATIENT',
      type: 'title',
      start: 'uf'
    },
    {
      text: 'DEVENIR DU PATIENT',
      type: 'title',
      start: 'dead'
    },
    {
      text: `DONNÉES RELATIVES À L'EXPOSITION AUX CVC, PICC OU CVO`,
      type: 'title',
      start: 'catheters'
    },
    {
      text: 'SEPSIS ET BACTÉRIÉMIES NON LIÉS À UN CVC, À UN PICC OU À UN CVO',
      type: 'title',
      start: 'sepsis'
    }
  ]
}

const patientFields = {
  v1: [
    patient.sheetNumber.v1,
    patient.ufs.neoInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.birthSite,
    cfg.origin.v1,
    patient.cribII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.birthWeight,
    patient.gestationalAge,
    patient.leucomalacy,
    patient.dead,
    patient.deathDate,
    patient.exitDate,
    cfg.future.v1
  ],

  v2: [
    patient.sheetNumber.v2,
    patient.ufs.neoInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.birthSite,
    cfg.origin.v2,
    patient.cribII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.birthWeight,
    patient.gestationalAge,
    patient.leucomalacy,
    patient.dead,
    patient.deathDate,
    patient.exitDate,
    cfg.future.v2
  ],

  v3: [
    patient.sheetNumber.v2,
    patient.ufs.neoInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.birthSite,
    cfg.origin.v2,
    patient.cribII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.birthWeight,
    patient.gestationalAge,
    patient.leucomalacy,
    patient.dead,
    patient.deathDate,
    patient.exitDate,
    cfg.future.v2,
    multi.covidStatus.exit
  ]
}

const catheters = (function () {
  const common = {
    removalDate: tools.select(catheter.removalDate, catheter.select.ktr),
    labo: {
      v1: tools.select(catheter.labo.v1, catheter.select.ktr),
      v2: tools.select(catheter.labo.v2, catheter.select.ktr)
    },
    diagDate: {
      v1: tools.select(bact.diagDate.v1, cfg.select.colIlcBlcSep),
      v2: tools.select(bact.diagDate.v2, cfg.select.colIlcBlcSep)
    },
    covidStatus: tools.select(multi.covidStatus.std, cfg.select.colIlcBlcSep),
    micro: (v) => tools.select(micro[v].noVirus, cfg.select.colIlcBlc),
    clinicalSigns: tools.select(bact.clinicalSigns, cfg.select.dd5),
    bioSigns: tools.select(bact.bioSigns, cfg.select.dd5),
    adaptedAntibio: tools.select(bact.adaptedAntibio, cfg.select.dd5),
    twoHemocs: tools.select(bact.twoHemocs, cfg.select.dd5)

  }

  const catheterFields = {
    v1: [
      cfg.material,
      catheter.insertionDate,
      cfg.insertionSite.v1,
      patient.neoVentilation,
      cfg.lipids,
      catheter.removed,
      common.removalDate,
      cfg.removalReason,
      common.labo.v1,
      cfg.isColIlcBlcSep,
      cfg.colIlcBlcSep,
      cfg.colIlcBlcSepOrigin.v1,
      cfg.lipidsDiagnosis.v1,
      cfg.blcCriteria.v1,
      common.micro('v1')
    ],

    v2: [
      cfg.material,
      catheter.insertionDate,
      cfg.insertionSite.v2,
      patient.neoVentilation,
      cfg.lipids,
      catheter.removed,
      common.removalDate,
      cfg.removalReason,
      common.labo.v2,
      cfg.isColIlcBlcSep,
      cfg.colIlcBlcSep,
      common.diagDate.v1,
      cfg.colIlcBlcSepOrigin.v2,
      common.covidStatus,
      cfg.lipidsDiagnosis.v1,
      cfg.blcCriteria.v1,
      common.micro('v2')
    ],

    v3: [
      cfg.material,
      catheter.insertionDate,
      cfg.insertionSite.v2,
      patient.neoVentilation,
      cfg.lipids,
      catheter.removed,
      common.removalDate,
      cfg.removalReason,
      common.labo.v2,
      cfg.isColIlcBlcSep,
      cfg.colIlcBlcSep,
      common.diagDate.v1,
      cfg.colIlcBlcSepOrigin.v2,
      common.covidStatus,
      cfg.lipidsDiagnosis.v1,
      cfg.blcCriteria.v2,
      common.clinicalSigns,
      common.bioSigns,
      common.adaptedAntibio,
      common.twoHemocs,
      common.micro('v3')
    ],

    v4: [
      cfg.material,
      catheter.insertionDate,
      cfg.insertionSite.v3,
      patient.neoVentilation,
      cfg.lipids,
      catheter.removed,
      common.removalDate,
      cfg.removalReason,
      common.labo.v2,
      cfg.isColIlcBlcSep,
      cfg.colIlcBlcSep,
      common.diagDate.v1,
      cfg.colIlcBlcSepOrigin.v2,
      common.covidStatus,
      cfg.lipidsDiagnosis.v2,
      cfg.blcCriteria.v2,
      common.clinicalSigns,
      common.bioSigns,
      common.adaptedAntibio,
      common.twoHemocs,
      common.micro('v3')
    ],

    v5: [
      cfg.material,
      catheter.insertionDate,
      cfg.insertionSite.v3,
      patient.neoVentilation,
      cfg.lipids,
      catheter.removed,
      common.removalDate,
      cfg.removalReason,
      common.labo.v2,
      cfg.isColIlcBlcSep,
      cfg.colIlcBlcSep,
      common.diagDate.v1,
      cfg.colIlcBlcSepOrigin.v2,
      common.covidStatus,
      cfg.lipidsDiagnosis.v2,
      cfg.blcCriteria.v2,
      common.clinicalSigns,
      common.bioSigns,
      common.adaptedAntibio,
      common.twoHemocs,
      common.micro('v4')
    ],

    v6: [
      cfg.material,
      catheter.insertionDate,
      cfg.insertionSite.v3,
      patient.neoVentilation,
      cfg.lipids,
      catheter.removed,
      common.removalDate,
      cfg.removalReason,
      common.labo.v2,
      cfg.isColIlcBlcSep,
      cfg.colIlcBlcSep,
      common.diagDate.v2,
      cfg.colIlcBlcSepOrigin.v2,
      common.covidStatus,
      cfg.lipidsDiagnosis.v2,
      cfg.blcCriteria.v2,
      common.clinicalSigns,
      common.bioSigns,
      common.adaptedAntibio,
      common.twoHemocs,
      common.micro('v5')
    ],

    v7: [
      cfg.material,
      catheter.insertionDate,
      cfg.insertionSite.v3,
      patient.neoVentilation,
      cfg.lipids,
      catheter.removed,
      common.removalDate,
      cfg.removalReason,
      common.labo.v2,
      cfg.isColIlcBlcSep,
      cfg.colIlcBlcSep,
      common.diagDate.v2,
      cfg.colIlcBlcSepOrigin.v2,
      common.covidStatus,
      cfg.lipidsDiagnosis.v2,
      cfg.blcCriteria.v2,
      common.clinicalSigns,
      common.bioSigns,
      common.adaptedAntibio,
      common.twoHemocs,
      common.micro('v6')
    ]
  }

  function build (field, select, list) {
    const result = [field]
    for (let i = 0; i !== list.length; ++i) {
      result.push(tools.andSelect(list[i], select))
    }
    return {
      field: fields.catheterArray,
      type: 'array',
      config: {
        title: 'CATHETER CENTRAL N°',
        fields: result
      }
    }
  }

  return {
    v1: build(cfg.catheterType.v1, cfg.select.kt.v1, catheterFields.v1),
    v2: build(cfg.catheterType.v2, cfg.select.kt.v2, catheterFields.v2),
    v3: build(cfg.catheterType.v2, cfg.select.kt.v2, catheterFields.v3),
    v4: build(cfg.catheterType.v2, cfg.select.kt.v2, catheterFields.v4),
    v5: build(cfg.catheterType.v2, cfg.select.kt.v2, catheterFields.v5),
    v6: build(cfg.catheterType.v2, cfg.select.kt.v2, catheterFields.v6),
    v7: build(cfg.catheterType.v2, cfg.select.kt.v2, catheterFields.v7),
    v8: build(cfg.catheterType.v3, cfg.select.kt.v3, catheterFields.v7)
  }
})()

const sepsisCommon = {
  episod: tools.select(bact.episod, cfg.select.sep),
  diagDate: tools.select(bact.diagDate.v1, cfg.select.sep),
  covidStatus: tools.select(multi.covidStatus.std, cfg.select.sep)
}

const sepsis = {
  v1: [
    cfg.sepPresent,
    sepsisCommon.episod,
    cfg.sepOrigin.v1,
    cfg.sepEntrance.v1
  ],

  v2: [
    cfg.sepPresent,
    sepsisCommon.episod,
    sepsisCommon.diagDate,
    cfg.sepOrigin.v2,
    sepsisCommon.covidStatus,
    cfg.sepEntrance.v2
  ],

  v3: [
    cfg.sepPresent,
    sepsisCommon.episod,
    sepsisCommon.diagDate,
    cfg.sepOrigin.v2,
    sepsisCommon.covidStatus,
    cfg.sepEntrance.v3
  ],

  v4: [
    cfg.sepPresent,
    sepsisCommon.episod,
    sepsisCommon.diagDate,
    cfg.sepOrigin.v2,
    sepsisCommon.covidStatus,
    cfg.sepEntrance.v4,
    tools.select(bact.lipids.sep.v1, cfg.select.sepC2C4)
  ],

  v5: [
    cfg.sepPresent,
    sepsisCommon.episod,
    sepsisCommon.diagDate,
    cfg.sepOrigin.v2,
    sepsisCommon.covidStatus,
    cfg.sepEntrance.v5,
    tools.select(bact.lipids.sep.v2, cfg.select.sepC2C8C9C12)
  ]
}

for (let k in sepsis) {
  sepsis[k] = {
    type: 'array',
    field: fields.sepsis,
    config: {
      title: 'SEPSIS N°',
      fields: sepsis[k]
    }
  }
}

export default {
  '2019': {
    titles: titles.v1,

    fields: [
      ...patientFields.v1,
      catheters.v1,
      sepsis.v1,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v1.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2019(result, sheet, surveillance)
    }
  },

  '2020': {
    titles: titles.v1,

    fields: [
      ...patientFields.v2,
      catheters.v2,
      sepsis.v2,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v2.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2020(result, sheet, surveillance)
    }
  },

  '2021': {
    titles: titles.v1,

    fields: [
      ...patientFields.v3,
      catheters.v3,
      sepsis.v3,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v3.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2021(result, sheet, surveillance)
    }
  },

  '2022': {
    titles: titles.v2,

    fields: [
      ...patientFields.v3,
      catheters.v4,
      sepsis.v4,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v4.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2022(result, sheet, surveillance)
    }
  },

  '2023': {
    titles: titles.v2,

    fields: [
      ...patientFields.v3,
      catheters.v5,
      sepsis.v4,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v5.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2023(result, sheet, surveillance)
    }
  },

  '2024': {
    titles: titles.v2,

    fields: [
      ...patientFields.v3,
      catheters.v6,
      sepsis.v4,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v6.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2024(result, sheet, surveillance)
    }
  },

  '2025': {
    titles: titles.v2,

    fields: [
      ...patientFields.v3,
      catheters.v7,
      sepsis.v4,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v7.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2025(result, sheet, surveillance)
    }
  },

  '2026': {
    titles: titles.v3,

    fields: [
      ...patientFields.v3,
      catheters.v8,
      sepsis.v5,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v8.neo
        }
      }
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2026(result, sheet, surveillance)
    }
  }
}
